import { Progress } from "@/components/ui/progress";
import { REPORTS } from "@/constants/testIds";

/** Lista de ocupación por profesional (horas ocupadas / disponibles), usada
 * en el Dashboard, el Dashboard reducido de Profesional y el tab de Reportes. */
export default function OccupancyBars({ data, testId = REPORTS.occupancyList }) {
  if (data.length === 0) {
    return <p className="text-sm text-muted-foreground py-6 text-center">Sin datos de agenda en este periodo.</p>;
  }
  return (
    <div className="space-y-4" data-testid={testId}>
      {data.map((p) => (
        <div key={p.professional_id} data-testid={`${REPORTS.occupancyRowPrefix}${p.professional_id}`}>
          <div className="flex items-center justify-between mb-1.5">
            <p className="text-sm font-medium text-foreground">{p.professional_name}</p>
            <p className="text-sm text-muted-foreground">
              {p.has_schedule === false
                ? "Sin horarios configurados"
                : `${p.occupancy_pct}% \u00b7 ${p.booked_hours}h / ${p.available_hours}h`}
            </p>
          </div>
          <Progress value={Math.min(p.occupancy_pct, 100)} className="h-2 bg-brand-light [&>div]:bg-brand" />
        </div>
      ))}
    </div>
  );
}
